import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { AccountService } from 'src/app/services/account.service';

@Component({

  selector: 'app-payment',

  templateUrl: './payment.component.html',

  styleUrls: ['./payment.component.css']

})

export class PaymentComponent implements OnInit {

  isSuccess: boolean = true;

  message = '';

  obj_Payment: any = {};

  invoiceDetail;

  constructor(

    private accountService: AccountService,

    private route: ActivatedRoute,

  ) { }

  ngOnInit(): void {
    
    this.route.queryParamMap.subscribe((query: any) => {

      if (query.params) {

        this.accountService.checkout_payment(query.params).subscribe((userData: string) => {

          let res = JSON.parse(userData);

          this.isSuccess = res.iResult || false;

          this.message = res.strError;

          this.obj_Payment = res;

          if (this.isSuccess) {

            this.invoiceDetail = JSON.parse(res.strDetail);

          }

        });

      }

    });

  }

  saveShot() {

    const element = document.getElementById('payment-receipt');

    if (!element) return;

    html2canvas(element, {

      scale: 2,

      useCORS: true,

      ignoreElements: (el) => {

        return el.classList.contains('payment-buttons');

      }

    }).then(canvas => {

      const link = document.createElement('a');

      link.download = `receipt-${this.obj_Payment?.strTransactionID}.png`;

      link.href = canvas.toDataURL('image/png');

      link.click();

    });

  }


}
